import { render, staticRenderFns } from "./AreaCard.vue?vue&type=template&id=5cbddea5&scoped=true&"
import script from "./AreaCard.vue?vue&type=script&lang=js&"
export * from "./AreaCard.vue?vue&type=script&lang=js&"
import style0 from "./AreaCard.vue?vue&type=style&index=0&id=5cbddea5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbddea5",
  null
  
)

export default component.exports